import React from "react";

interface CardProps {
  children: React.ReactNode;
  marginTop?: number;
  padding?: number;
  height?: number;
  width?: number;
  color?: string;
  borderRight?: boolean;
  className?: string;
}
const Card = ({
  children,
  padding,
  marginTop,
  height,
  width,
  color,
  borderRight,
  className,
}: CardProps) => {
  return (
    <div
      className={`${className} p-${padding} bg-transparent shadow-lg  flex justify-center border transition-colors duration-700 ease-in-out ${
        borderRight ? `` : ""
      }`}
      style={{
        marginTop: marginTop,
        backgroundColor: color,
      }}
    >
      {children}
    </div>
  );
};

export default Card;
